import React from 'react'
import { getSearchUrls, openSearchWindow } from '../../utils/constants'

// Available search buttons keyed by id. `order` lets callers control the
// left-to-right sequence; default keeps the historical Reverb-first order.
const BUTTONS = {
  reverbSold: { urlKey: 'reverbSold', title: 'Reverb Sold', label: 'R' },
  ebaySold:   { urlKey: 'ebaySold',   title: 'eBay Sold',   label: 'eS' },
  ebayActive: { urlKey: 'ebayActive', title: 'eBay Active', label: 'eA' },
  google:     { urlKey: 'google',     title: 'Google',      label: 'G' },
}

const DEFAULT_ORDER = ['reverbSold', 'ebaySold', 'ebayActive', 'google']

function SearchLinks({ title, order = DEFAULT_ORDER }) {
  const urls = getSearchUrls(title)

  return (
    <div className="search-links">
      {order.map((id) => {
        const btn = BUTTONS[id]
        if (!btn) return null
        return (
          <button
            key={id}
            onClick={() => openSearchWindow(urls[btn.urlKey])}
            title={btn.title}
            className="search-link-btn"
          >
            {btn.label}
          </button>
        )
      })}
    </div>
  )
}

export default SearchLinks
